/* eslint-disable react-refresh/only-export-components */
import { createContext, useContext } from 'react';

import type { CookiePreferences } from '@global/types/cookie-consent';

export interface CookieConsentContextValue {
  prefs: CookiePreferences | null;
  hasConsent: (category: keyof CookiePreferences) => boolean;
  updatePreferences: (prefs: CookiePreferences) => void;
  showConsentDialog: () => void;
}

export const CookieConsentContext = createContext<CookieConsentContextValue | null>(null);

export const useCookieConsent = (): CookieConsentContextValue => {
  const context = useContext(CookieConsentContext);

  if (!context) {
    throw new Error('useCookieConsent must be used within CookieConsentProvider');
  }

  return context;
};
